import PLANS_PATH from '../../constants/path'
import getStartedPlanSelect from '../get-started'
import getLoggedPlansCountProfileSelect from '../../../profile/redux/selectors/get-logged-plans-count'
import getCurrentReduxSelector from '../../../redux/selectors/get-current'
import { createSelector } from 'reselect'

const getSuggestedPlanSelect = createSelector(
  getStartedPlanSelect,
  getLoggedPlansCountProfileSelect,
  getCurrentReduxSelector(PLANS_PATH.DATA, PLANS_PATH.SUGGESTED),
  (plan, loggedPlansCount, suggestedPlan) => {
    return suggestedPlan
  }
)

export default getSuggestedPlanSelect
